import { useNavigate } from 'react-router-dom'
import { t } from '../i18n/index.js'
import { addDays } from '../lib/format.js'
import { DayProgress } from './DayProgress.js'
import { PropertyGroup, groupByProperty } from './PropertyGroup.js'
import { TaskCard, TaskSkeleton } from './TaskCard.js'
import { WeekStrip } from './WeekStrip.js'
import { WorkerShell, useWorkerTasks } from './shell.js'

export function TodayPage() {
  const navigate = useNavigate()
  const { tasks, today, byDay, isLoading, isError } = useWorkerTasks()
  // `isLoading` is only true when there is nothing cached to show yet.
  const showSkeleton = isLoading && tasks.length === 0

  const todayTasks = tasks.filter((task) => task.dueDate === today)
  const overdue = tasks.filter((task) => task.dueDate < today && task.status !== 'done')
  const todayOpen = todayTasks.filter((task) => task.status !== 'done')
  const doneToday = todayTasks.filter((task) => task.status === 'done')
  const tomorrow = tasks.filter((task) => task.dueDate === addDays(today, 1) && task.status !== 'done')

  return (
    <WorkerShell title={t('app.title')}>
      <WeekStrip
        today={today}
        byDay={byDay}
        loading={isLoading && tasks.length === 0}
        onSelect={(date) => navigate(`/app/plan?tag=${date}`)}
      />

      {showSkeleton && <TaskSkeleton />}

      {isError && tasks.length === 0 && !isLoading && (
        <div className="notice warn">
          {t('today.load_failed')}
        </div>
      )}

      {!showSkeleton && <DayProgress done={doneToday.length} total={todayTasks.length} />}

      {!showSkeleton && overdue.length > 0 && (
        <>
          <div className="wk-section-title">{t('today.overdue')}</div>
          {overdue.map((task) => (
            <TaskCard key={task.id} task={task} today={today} showDate />
          ))}
        </>
      )}

      {!showSkeleton && (
        <>
          <div className="wk-section-title">{t('today.today')}</div>
          {todayOpen.length === 0 ? (
            <p className="muted" style={{ fontSize: 17 }}>
              {todayTasks.length > 0 ? t('today.all_done') : t('today.empty')}
            </p>
          ) : (
            groupByProperty(todayOpen).map((group) => (
              <PropertyGroup key={group.key} group={group} today={today} />
            ))
          )}
        </>
      )}

      {tomorrow.length > 0 && (
        <>
          <div className="wk-section-title">{t('today.tomorrow')}</div>
          {groupByProperty(tomorrow).map((group) => (
            <PropertyGroup key={group.key} group={group} today={today} />
          ))}
        </>
      )}

      {doneToday.length > 0 && (
        <>
          <div className="wk-section-title">{t('today.done')}</div>
          {doneToday.map((task) => (
            <TaskCard key={task.id} task={task} today={today} />
          ))}
        </>
      )}
    </WorkerShell>
  )
}
